import { Component, effect, input, model, viewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { distinctUntilChanged } from 'rxjs';
import { Tabular } from '../../services/tabular';

@Component({
  selector: 'nem-tabular',
  templateUrl: './nem-tabular.comp.html',
  styles: [
    `
      .cell-style {
        border: 1px solid #e2e8f0 !important; /* border-slate-200 */
        text-align: right !important;
        padding: 0.2rem 0.5rem !important;
        transition: border-color 0.3s ease, background-color 0.3s ease;
      }
      .header-style {
        padding-right: 0 !important;
      }
    `
  ],
  standalone: false
})
export class NemTabularComponent {
  tabular = input<Tabular | null>(null);
  loading = input<boolean>(false);
  dateFormat = input.required<string>();

  syncScrolling = model<boolean>(true);

  table = viewChild<Table>('table');

  constructor() {
    effect(onCleanup => {
      const tab = this.tabular();
      if (!tab) return;

      const sub = tab.xy$.pipe(distinctUntilChanged((a, b) => a[0] === b[0] && a[1] === b[1])).subscribe(([rdx]) => {
        if (this.syncScrolling() && this.table()) {
          if (rdx !== -1) {
            this.table()?.scroller?.scrollToIndex(rdx, 'smooth');
          }
        }
      });

      onCleanup(() => sub.unsubscribe());
    });
  }
}
